// extracted by mini-css-extract-plugin
export default {"line":"View_line__G8Q2R","title":"View_title__EKxpg","tooltip":"View_tooltip__zylMv","switch":"View_switch__RLjn8"};